import { Component } from 'react';
import classnames from 'classnames';
import classNames from 'classnames/bind';

import styles from './styles.scss';

let cx = classNames.bind(styles);

export default class CollapsableSelectList extends Component {
  render() {
    var onFormActions = this.props.onFormActions;
    let className = cx({
      collapsableSelectList: true,
      onFormActions: onFormActions,
    });

    return <div className={classnames(className)}>{this.props.children}</div>;
  }
}
